<template>
<div>
    <h1 class="subtitle">Empleados</h1>
    <div class="nj-cols">
        <div class="nj-card">
            <div class="nj-cols form c3">
                <div>
                    <div class="nj-label">Empleado</div>
                    <input type="text" class="nj-text" v-model="empleado.emp_search">
                </div>
                <div>
                    <div class="nj-label">Estado</div>
                    <select name="" id="" class="nj-select" v-model="empleado.emp_estado">
                        <option value="">Todos los estados</option>
                        <option v-for="item in estados" :key="item.est_id" :value="item.est_id">{{ item.est_nombre }}</option>
                    </select>
                </div>
            </div>
            <Buttons line>
                <button class="nj-button" @click="paginar()">Buscar</button>
                <button class="nj-button c-green" @click="openRegistrar()">Nuevo</button>
                <!-- <button class="nj-button c-blue" @click="openCargarEmpleados()">Cargar empledos</button> -->
            </Buttons>
        </div>
        <div class="nj-card">
            <b-table :data="empleados" @page-change="changePage($event)" :total="empleado.page.total" :per-page="empleado.page.size" :current-page="empleado.page.number" :paginated="true"
                :backend-pagination="true" pagination-order="is-centered">
                <template slot-scope="props">
                    <b-table-column label="DNI" header-class="is-info">{{ props.row.emp_dni }}</b-table-column>
                    <b-table-column label="Empleado" header-class="is-info">{{ props.row.emp_nombre }} {{ props.row.emp_apellido }}</b-table-column>
                    <b-table-column label="Puesto" header-class="is-info">{{ props.row.pue_nombre }}</b-table-column>
                    <b-table-column label="Usuario" header-class="is-info">
                        <b-tag :class="props.row.usu_id ? 'nj-tag c-green' : 'nj-tag c-red'">{{ props.row.usu_id ? 'SI' : 'NO' }}</b-tag>
                    </b-table-column>
                    <b-table-column label="Estado" header-class="is-info">
                        <b-tag :class="props.row.est_styles">{{ props.row.est_nombre }}</b-tag>
                    </b-table-column>
                    <b-table-column label="Opciones" header-class="is-info">
                        <div class="nj-flx">
                            <button class="nj-button icon" @click="openModificar(props.row.emp_id)" title="Modificar"><i class="mdi mdi-pencil"></i></button>
                        </div>
                    </b-table-column>
                </template>
            </b-table>
        </div>
    </div>
    <RegistrarEmpleado v-if="activarRegistrar" @close="closeRegistrar($event)" />
    <ModificarEmpleado v-if="activarModificar" :emp_id="emp_id" @close="closeModificar($event)" />
    <EmpleadosCargar v-if="activarCargarEmpleados" :emp_id="emp_id" @close="closeCargarEmpleados($event)" />
</div>
</template>

<script>
import Estado from "../../constants/estado"
import { EmpleadoService, ResponseStatus } from "../../services"
import ModificarEmpleado from "./ModificarEmpleado"
import RegistrarEmpleado from "./RegistrarEmpleado"
import EmpleadosCargar from "./EmpleadosCargar"
import { Buttons } from "../components"
import Keyboard from "../../util/keyboard"
import Toast from "../../util/toast"
import { Data } from "../../util"
import Arrays from "../../util/arrays"

export default {
    name: "Empleado",
    components: {
        RegistrarEmpleado,
        ModificarEmpleado,
        EmpleadosCargar,
        Buttons,
        Keyboard,
    },
    data() {
        return {
            empleado: {
                emp_search: null,
                emp_estado: null,
                page: {
                    number: 1,
                    size: 10,
                    total: 0
                },
            },
            empleados: [],
            activarRegistrar: false,
            activarModificar: false,
            activarCargarEmpleados: false,
            emp_id: null,
            estados: [],
        }
    },
    methods: {
        changePage(number) {
            this.empleado.page.number = number
            this.paginar()
        },
        paginar() {
            EmpleadoService
                .paginar({
                    empleado: this.empleado,
                })
                .then(response => {
                    if (ResponseStatus.isSuccess(response)) {
                        this.empleado.page = response.data
                        this.empleados = this.empleado.page.list
                    }
                    else {
                        Toast.error(response.message)
                    }
                })
                .catch(error => {
                    Toast.error(error)
                    console.error(`error: `, error)
                })
        },
        tagEstado(id) {
            return Estado.Tag(id)
        },
        openRegistrar() {
            this.activarRegistrar = true
        },
        closeRegistrar(condition) {
            this.activarRegistrar = false
            if (condition) {
                this.paginar()
            }
        },
        openModificar(id) {
            this.emp_id = id
            this.activarModificar = true
        },
        closeModificar(condition) {
            this.emp_id = null
            this.activarModificar = false
            if (condition) {
                this.paginar()
            }
        },
        openCargarEmpleados() {
            this.activarCargarEmpleados = true
        },
        closeCargarEmpleados() {
            this.activarCargarEmpleados = false
        },
        buscarProyecto(event) {
            if (event.keyCode == 13) {
                if (this.alm_nombre) {
                    AlmacenService
                        .buscarRapido({
                            alm_nombre: this.alm_nombre
                        }).then(response => {
                            this.almacenes = response.data
                        }, error => {
                            Toast.error(error)
                            console.error(`error: `, error)
                        })
                }
                else {
                    Toast.error("Debe ingresar alguna referencia del almacen")
                    this.productos = []
                }
            }
            else {
                this.productos = []
            }
        },
        // popup({ componente, abrir, buscar = false, cli_id = null }) {
        //     this.cli_id = cli_id
        //     switch (componente) {
        //         case "registrar":
        //             // registrar 
        //             this.activarRegistrar = abrir
        //             break
        //         case "ver":
        //             // ver
        //             this.activarVer = abrir
        //             break
        //         case "modificar":
        //             // modificar
        //             this.activarModificar = abrir
        //             break
        //         case "all":
        //             // cerrar todo
        //             this.activarRegistrar = false
        //             this.activarVer = false
        //             this.activarModificar = false
        //             break
        //     }
        //     if (buscar) {
        //         this.paginar()
        //     }
        // },
    },
    mounted() {
        this.estados = Arrays.filter(Data.get(Data.listNames.estados), "est_codigo", ["activo", "inactivo"])
        this.empleado.emp_estado = Arrays.find(this.estados, "est_codigo", "activo").est_id
        this.paginar()
    },
}
</script>

<style scoped></style>